(($, window, undefined) => {
    if (window.mg === undefined)
        window.mg = {};

    const _ = window.mg;

    const load = ($target, url, data) => {
        $target.empty().html(
            '<div class="calendar-spinner-wrapper">' +
                '<div class="spinner spinner-blue"></div>' +
            '</div>'
        );

        return _.ajax.get({
            url,
            data,
            dataType : 'html',
            cache    : false,
        }).done((data) => {
            $target.empty().html(data);
        });
    };

    const getDetails = (itemTime, slotID, compID, listType, maxExpand, filterType, filterPeriodFrom, filterPeriodTo) => { // Includes all these parameters to match the cache key properly
        const url  = '/Site/Calendar/?handler=Details';
        const data = {
            itemTime,
            slotID,
            compID,
            listType,
            maxExpand,
            filterType,
            filterPeriodFrom,
            filterPeriodTo
        };

        return _.ajax.get(url, data);
    };

    class Calendar {
        constructor() {
            this._modalPleaseWait = null;
            this._modalDetails    = null;

            this._htmlDetailsView = null;
            this._htmlCancelView  = null;
        }

        loadFutureRounds(max, expandable, maxExpand, filterType, filterPeriodFrom, filterPeriodTo, isFirstLoad, isStartPage) {
            const $target = $('.calendar-futurerounds-wrapper');
            const url     = '/Site/Calendar/?handler=FutureRounds';
            const options = {
                max,
                expandable,
                maxExpand,
                filterType,
                filterPeriodFrom,
                filterPeriodTo,
                isFirstLoad,
                isStartPage
            };

            return load($target, url, options);
        }

        loadPreviousRounds(max, expandable, maxExpand, filterType, filterPeriodFrom, filterPeriodTo, isFirstLoad, isStartPage) {
            const $target = $('.calendar-previousrounds-wrapper');
            const url     = '/Site/Calendar/?handler=PreviousRounds';
            const options = {
                max,
                expandable,
                maxExpand,
                filterType,
                filterPeriodFrom,
                filterPeriodTo,
                isFirstLoad,
                isStartPage
            };

            return load($target, url, options);
        }

        updateFutureRounds() {
          // Dummy for override
        }

        updatePreviousRounds() {
          // Dummy for override
        }

        showDetails(itemTime, slotID, compID, listType, maxExpand, filterType, filterPeriodFrom, filterPeriodTo, props) {
            props = props || {};
            this._modalPleaseWait = _.ui.showPleaseWaitModal();

            this._htmlDetailsView = null;
            this._htmlCancelView  = null;

            var done = (data) => {
                this._modalPleaseWait.close();

                if (!data)
                    return;

                var hasError = data.ErrorMessage;
                var isCompetition = data.CompetitionID !== undefined && data.CompetitionID !== null;

                var title = _.translations.BookedTeeTime;
                var headerHTML = [];

                if (isCompetition) {
                    var entry = null;
                    title = '<a href="/Competition/' + data.CompetitionID + '">' + data.CompetitionName + '</a>';

                    data.Players && $.each(data.Players, function (k, v) {
                        if (v.IsSelf) {
                            entry = v;
                            return false; // Break the loop
                        }
                    });

                    var formatHeaderValue = function (title, value) {
                        return '<span>' + title + ': </span><span class="font-bold">' + (value || '') + '</span>';
                    };

                    var formatEntryValue = function (title, property, allowSearchInTeam) {
                        var value = entry ? entry[property] : null;

                        if (allowSearchInTeam && data.Teams && entry) {
                            var team = null;

                            $.each(data.Teams, (k, v) => { // Search for the team that has the currenty entry
                                v.Entries && $.each(v.Entries, (kE, vE) => {
                                    $.each(data.Players, (kP, vP) => {
                                        if (vP.EntryID === vE) {
                                            team = v;
                                            return false; // Break the vP-loop
                                        }
                                    });

                                    if (team)
                                        return false; // Break the vE-loop
                                });

                                if (team)
                                    return false; // Break the v-loop
                            });

                            if (team && team[property]) {
                                value = team[property];
                            }
                        }

                        return formatHeaderValue(title, value);
                    };

                    headerHTML = [
                        '<div class="details-header-inner">',
                            '<div class="row">',
                                '<div class="col-12 col-lg-10">',
                                    '<div class="row split-width font-bold">',
                                        '<div class="col-auto">' + data.FormattedDay + '</div>',
                                        '<div class="col col-lg-auto text-truncate">' + data.ClubName + '</div>',
                                        '<div class="col-12 col-lg-auto">' + (data.CourseName || '') + '</div>',
                                    '</div>',
                                '</div>',
                                '<div class="col-12">',
                                    '<div class="row split-width">',
                                        '<div class="col-6 col-lg-auto">' + formatHeaderValue(_.translations.StartTime, data.FormattedTime) + '</div>',
                                        '<div class="col-6 col-lg-auto">' + formatEntryValue(_.translations.StartHole, 'StartHole') + '</div>',
                                        '<div class="col-6 col-lg-auto">' + formatEntryValue(_.translations.PHCP, 'PHCP', true) + '</div>',
                                        '<div class="col-6 col-lg-auto">' + formatEntryValue(_.translations.Tee, 'Tee') + '</div>',
                                        '<div class="col-6 col-lg-auto">' + formatEntryValue(_.translations.Class, 'ClassName') + '</div>',
                                    '</div>',
                                '</div>',
                            '</div>',
                        '</div>',
                        (function () {
                            var $expandable = $('.mg-expandable-wrapper .expandable').clone();
                            var newExpandableID = 'expandable-' + mg.getUniqueNumber();
                            var newExpandableCollapseID = newExpandableID + '-collapse';

                            $expandable.attr('id', newExpandableID);
                            var $icon = $expandable.find('> a > .icon').remove();
                            $expandable.find('> a').attr('aria-controls', newExpandableCollapseID).attr('href', '#' + newExpandableCollapseID).append('<span>' + mg.translations.SeeYourChoices + '</span>' + $icon[0].outerHTML);
                            $expandable.find('.collapse').attr('id', newExpandableCollapseID);

                            var content = [];
                            var renderQuestionsHeader = function (title, titleClassName) {
                                return [
                                    '<div' + (titleClassName ? ' class="' + titleClassName + '"' : '') + '>',
                                        '<b>' + title + '</b>',
                                    '</div>'
                                ].join('');
                            };

                            var renderRequest = function (title, text) {
                                return [
                                    '<div class="col-auto">',
                                        '<span class="request-description">' + title + ':</span>',
                                        text ? '<b>' + text + '</b>' : '',
                                    '</div>'
                                ].join('');
                            };

                            var renderQuestions = function (questions) {
                                var html = [];

                                if (questions && questions.length) {
                                    $.each(questions, function (k, v) {
                                        var hasAnswerText = v.Answer !== '';
                                        var hasPrice = v.Price;
                                        var priceTemplate = hasAnswerText ? '(%price%)' : '%price%';

                                        var requestContent = [];
                                        hasAnswerText && requestContent.push('<span>&nbsp;' + v.Answer + '</span>');
                                        hasPrice && requestContent.push('<span>&nbsp;' + priceTemplate.replace('%price%', _.cc.formatAmount(v.Price ? v.Price.Value : 0, true, true)) + '</span>');

                                        html.push(renderRequest(v.Text, requestContent.join('')));
                                    });
                                }

                                return html.join('');
                            };

                            var hasTeam = data.Teams && data.Teams.length > 0;
                            var requestsContent = [];
                            var requestsContentTeam = [];

                            var questionsContent = renderQuestions(data.Players[0].Questions);
                            questionsContent && requestsContent.push(questionsContent);

                            var req = data.Players[0].Requests;

                            if (req) {
                                var reqContent = [];

                                var renderReq = function (text, value) {
                                    value && reqContent.push(renderRequest(text, '&nbsp;' + value));
                                };

                                renderReq(mg.translations.TeeTimeWish, req.TeeTimeWish);
                                renderReq(mg.translations.GolfCart, req.GolfCart ? mg.translations.Yes : '');
                                renderReq(mg.translations.Caddie, req.Caddie ? mg.translations.Yes : '');
                                renderReq(mg.translations.Tee, req.TeeName);
                                renderReq(mg.translations.MessageForTheClubOrCompetitionLeader, req.Note);

                                var reqHTML = reqContent.join('');
                                reqHTML && requestsContent.push(reqHTML);
                            }

                            if (requestsContent.length) {
                                content.push([
                                    hasTeam ? renderQuestionsHeader(mg.translations.YourChoices) : '',
                                    '<div class="row choices">',
                                        requestsContent.join(''),
                                    '</div>'
                                ].join(''));
                            }

                            if (hasTeam) {
                                var teamQuestionsContent = renderQuestions(data.Teams[0].Questions);
                                teamQuestionsContent && requestsContentTeam.push(teamQuestionsContent);

                                if (requestsContentTeam.length) {
                                    content.push([
                                        renderQuestionsHeader(mg.translations.TheTeamsChoices, 'team-choices-header'),
                                        '<div class="row choices">',
                                            requestsContentTeam.join(''),
                                        '</div>'
                                    ].join(''));
                                }
                            }

                            content = content.join('');
                            $expandable.find('.collapse-content').html(content);

                            return content ? [
                                '<div class="header-requests">',
                                    $expandable[0].outerHTML,
                                '</div>'
                            ].join('') : '';
                        })()
                    ];
                }
                else {
                    headerHTML = [
                        '<div class="details-header-inner">',
                            '<div class="row font-bold">',
                                '<div class="col-5 col-lg-2 order-lg-1">' + data.FormattedDay + '</div>',
                                '<div class="col-7 col-lg-3 order-lg-3">' + data.ClubName + '</div>',
                                '<div class="w-100 d-lg-none"></div>',
                                '<div class="col-5 col-lg-2 order-lg-2">' + data.FormattedTime + '</div>',
                                '<div class="col-7 col-lg order-lg-4 course-name">' + data.CourseName + '</div>',
                            '</div>',
                        '</div>'
                    ];
                }

                if (props.onDeleteSuccess && $.isFunction(props.onDeleteSuccess))
                    data.onDeleteSuccess = props.onDeleteSuccess;

                var renderAsHidden = props.renderDetailsAsHidden;

                this._htmlDetailsView = [
                    '<div class="details' + (hasError ? ' hasError' : '') + (renderAsHidden ? ' hide' : '') + '">',
                        '<div class="details-header">',
                            headerHTML.join(''),
                        '</div>',

                        '<div class="details-body' + (isCompetition ? ' db-competition' : '') + '">',
                            (() => {
                                const rows = [];

                                var renderSeparator = () => {
                                    rows.push('<hr />');
                                };

                                if (isCompetition) {
                                    var renderPrice = (amount, totalPaid, forceOneLine) => {
                                        if (amount) {
                                            var price = _.cc.formatAmount(amount.Value, true, true);
                                            return _.ui.helpers.renderPrice(price, amount.Value > 0 && totalPaid >= amount.Value, forceOneLine);
                                        }

                                        return '';

                                    };

                                    var renderPlayer = (player, team) => {
                                        var genderIconClass = mg.getGenderIconClass(player.Gender);

                                        var getFirstColumn = function (content, isFirst, iconClass) { // We want the first column of each row to align the content. This is achieved by including the gender icon in each row, and only showing it on the first row
                                            var genderIcon = '<i class="icon icon-' + mg.getGenderIconClass(player.Gender) + (isFirst ? '' : ' invisible') + (iconClass ? ' ' + iconClass : '') + '"></i>';

                                            return [
                                                '<div class="d-flex align-items-center">',
                                                    genderIcon,
                                                    '<span>' + content + '</span>',
                                                '</div>'
                                            ].join('');
                                        };

                                        var phcp = player.PHCP && (!team || !team.PHCP) ? player.PHCP : ''; // We only show a player's PHCP if the player is not in any team, or if the player's team does not have a PHCP
                                        var tee = player.Tee;
                                        var price = renderPrice(player.Price, player.TotalPaid);
                                        
                                        rows.push([
                                            '<div class="row">',
                                                '<div class="col-12 col-lg-8 order-lg-0">',
                                                    '<div class="row">',
                                                        '<div class="col-6 bold">' + player.Name + '</div>',
                                                        '<div class="col-6 bold text-right text-lg-left">' + player.HCP + '</div>',
                                                        '<div class="col-6">' + player.GolfID + '</div>',
                                                        '<div class="col-6 text-right text-lg-left">' + player.ClubName + '</div>',
                                                    '</div>',
                                                '</div>',
                                                phcp || tee ? [
                                                    '<div class="col order-lg-2">',
                                                        '<div class="row h-100 align-items-center">',
                                                            phcp ? '<div class="col-6 col-lg-12 bold text-lg-right">' + phcp + '</div>' : '',
                                                            tee ? '<div class="col-6 col-lg-12' + (phcp ? ' text-right' : '') + ' text-lg-right">' + tee + '</div>' : '', // In mobile mode this is only shown as right-aligned if phcp is shown
                                                        '</div>',
                                                    '</div>'
                                                ].join('') : '',
                                                price ? [
                                                    '<div class="col order-lg-1">',
                                                        '<div class="row h-100 align-items-center">',
                                                            '<div class="col">' + price + '</div>',
                                                        '</div>',
                                                    '</div>'
                                                ].join('') : '',
                                            '</div>'
                                        ].join(''));
                                    };

                                    if (data.Teams && data.Teams.length > 0) {
                                        $.each(data.Teams, (k, v) => {
                                            var price = renderPrice(v.Price, v.TotalPaid, true); // We set forceOneLine to true, as we want to show this content on one line for this particular case

                                            var teamValues = ['<span>' + (v.Name || '-') + '</span>'];
                                            v.PHCP && teamValues.push('<span class="phcp">' + _.translations.PHCP + ': ' + v.PHCP + '</span>');
                                            price && teamValues.push('<span>' + price + '</span>');

                                            rows.push('<div class="team-row">' + teamValues.join('<span class="divider">|</span>') + '</div>');

                                            v.Entries && $.each(v.Entries, (kE, vE) => {
                                                var player = null;

                                                $.each(data.Players, function (kP, vP) {
                                                    if (vP.EntryID === vE) {
                                                        player = vP;
                                                        return false; // Break the loop
                                                    }
                                                });

                                                if (player) {
                                                    kE === 0 && renderSeparator();
                                                    renderPlayer(player, v);
                                                    renderSeparator();
                                                }
                                            });
                                        });
                                    }
                                    else {
                                        renderSeparator();

                                        data.Players && $.each(data.Players, (k, v) => {
                                            renderPlayer(v);

                                            renderSeparator();
                                        });
                                    }
                                }
                                else {
                                    data.Players && $.each(data.Players, (k, v) => {
                                        const country = v.CountryCode ? _.countries.byCountryIsoCode(v.CountryCode) : null;
                                        k !== 0 && renderSeparator();

                                        var priceContent = '';

                                        if (!hasError && v.Price) // If there was an error we won't have a price to show
                                            priceContent = _.ui.helpers.renderPrice(_.cc.formatAmount(v.Price.Value, true, true), v.Price.Value > 0 && v.TotalPaid >= v.Price.Value);
                                            
                                        rows.push([
                                            '<div class="row">',
                                                '<div class="col-12 col-sm-9 col-lg-10">',
                                                    '<div class="row">',
                                                        '<div class="col-12 col-lg-4 order-lg-0">',
                                                            '<div class="row">',
                                                                '<div class="col-7 col-sm-12">',
                                                                    '<div class="row no-gutters">',
                                                                        '<div class="col col-sm-auto col-lg mr-1 mr-sm-2">',
                                                                            '<b>' + v.Name + '</b>',
                                                                        '</div>',
                                                                        '<div class="col-auto d-lg-none align-self-center">', // Hiding on lg, as we have a different column we want shown there (we can't properly restore the gutters we have removed)
                                                                            '<b>' + (!v.ShowAsGuest ? v.HCP : '') + '</b>',
                                                                        '</div>',
                                                                    '</div>',
                                                                '</div>',
                                                                '<div class="col-5 d-sm-none align-self-center">', // Hiding on sm, as we have a different column we want shown there
                                                                    priceContent,
                                                                '</div>',
                                                            '</div>',
                                                        '</div>',
                                                        '<div class="col-lg-5 d-none d-lg-block order-lg-1"><b>' + (!v.ShowAsGuest ? v.HCP : '') + '</b></div>', // Only shown on lg and above
                                                        '<div class="col col-sm-9 col-lg-4 order-lg-3">' + (!v.ShowAsGuest ? ((((v.GolfID??'' !== '') ? v.GolfID :  (v.ForeignId??'' !== '') ? v.ForeignId:'-' ))) : '') + '</div>',
                                                        '<div class="col-auto col-sm-3 col-lg-3 order-lg-2">' + (!v.ShowAsGuest ? (country ? country.ShortName : '-') : '') + '</div>',
                                                        '<div class="w-100 d-sm-none"></div>',
                                                        '<div class="col col-sm-9 col-lg-5 order-lg-4">' + (!v.ShowAsGuest ? (v.ClubName || '-') : '') + '</div>',
                                                        '<div class="col-auto col-sm-3 col-lg-3 order-lg-5">' + (!v.ShowAsGuest ? (v.Gender === 0 ? _.translations.Woman : _.translations.Man) : '') + '</div>',
                                                    '</div>',
                                                '</div>',
                                                '<div class="col-3 col-lg-2 d-none d-sm-block align-self-end align-self-lg-center">',
                                                    priceContent,
                                                '</div>',
                                            '</div>'
                                        ].join(''));
                                    });
                                }

                                if (hasError)
                                    rows.push('<div class="error-message">' + data.ErrorMessage + '</div>');

                                return rows.join('');
                            })(),
                        '</div>',

                        '<div class="details-footer">',
                            '<div class="btn-wrapper">',
                                (function() {
                                    var renderButton = (text, className, onclick, disabled) => {
                                        return '<button class="btn ' + className + (disabled ? ' disabled' : '') + '"' + (onclick && !disabled ? ' onclick="' + onclick + '"' : '') + (disabled ? ' disabled="disabled"' : '') + '>' + text + '</button>';
                                    };

                                    var btns = [];
                                    var btnPayVisible = data.AllowPayment;
                                    var btnEditVisible = true;
                                    var btnDeleteVisible = true;

                                    var btnPayText = _.translations.Pay;
                                    var btnEditText = _.translations.Edit;
                                    var btnDeleteText = _.translations.CancelTeeTime;

                                    var btnPayOnClick = 'mg.calendar.openBooking(\'' + data.SlotID + '\', true)';
                                    var btnEditOnClick = 'mg.calendar.openBooking(\'' + data.SlotID + '\', false)';
                                    var btnDeleteOnClick = 'mg.calendar.deleteBooking()';

                                    var btnPayDisabled = true;
                                    var btnEditDisabled = true;
                                    var btnDeleteDisabled = true;

                                    if (data.PayAction) {
                                        btnPayVisible = data.PayAction.Visible;
                                        btnPayDisabled = !data.PayAction.Enabled;
                                    }

                                    if (data.EditAction) {
                                        btnEditVisible = data.EditAction.Visible;
                                        btnEditDisabled = !data.EditAction.Enabled;
                                    }

                                    if (data.DeleteAction) {
                                        btnDeleteVisible = data.DeleteAction.Visible;
                                        btnDeleteDisabled = !data.DeleteAction.Enabled;
                                    }

                                    if (isCompetition) {
                                        btnDeleteText = mg.translations.DeleteCompetitionSignup;

                                        btnPayOnClick = 'mg.calendar.openCompetitionSignup(\'' + data.CompetitionID + '\', true)';
                                        btnEditOnClick = 'mg.calendar.openCompetitionSignup(\'' + data.CompetitionID + '\', false)';
                                        btnDeleteOnClick = 'mg.calendar.deleteCompetitionSignup()';
                                    }

                                    if (data.IsTeenTour) {
                                        btnPayText = _.translations.Confirm;
                                        btnDeleteText = _.translations.TeenTourDelete;
                                    }

                                    return [
                                        btnPayVisible ? renderButton(btnPayText, 'pay-calendar-item ' + (!btnPayDisabled ? 'btn-primary' : 'btn-blacksqueeze'), btnPayOnClick, btnPayDisabled) : '',
                                        btnEditVisible ? renderButton(btnEditText, 'edit-calendar-item ' + (!btnEditDisabled ? 'btn-primary' : 'btn-blacksqueeze'), btnEditOnClick, btnEditDisabled) : '',
                                        btnDeleteVisible ? renderButton(btnDeleteText, 'btn-blacksqueeze delete-calendar-item', btnDeleteOnClick, btnDeleteDisabled) : ''
                                    ].join('');
                                })(),
                            '</div>',
                            '<div class="link-wrapper">',
                                '<a href="javascript:void(mg.calendar.saveToCalendar(\'' + data.Time + '\', \'' + (data.ClubName || '').replace(/'/g, '\\\'') + '\', \'' + (data.CourseName || 'null').replace(/'/g, '\\\'') + '\'))">' + _.translations.SaveToCalendar + '</a>',
                            '</div>',
                        '</div>',
                    '</div>'
                ].join('');

                setTimeout(() => {
                    this._modalDetails = _.ui.actionmodal({
                        title         : title,
                        titleInHeader : true,
                        html          : this._htmlDetailsView,
                        hideStateIcon : true,
                        hideFooter    : true,
                        modalBodyFull : true,

                        _data         : data,

                        onOpen        : function() {
                            var that = this;

                            var handleAction = function (action, btnClass, onErrorModalClose) {
                                if (action && action.DisabledReasons && action.DisabledReasons.length > 0) {
                                    var $btn = $('.' + btnClass, '#' + that.id);
                                    var errors = [];

                                    $.each(action.DisabledReasons, function (k, v) {
                                        var err = mg.resolveError(v);

                                        if (err && err[err.length - 1] === '.')
                                            err = err.substr(0, err.length - 1); // Remove trailing dots from error texts as we are adding one here as well.

                                        errors.push(err);
                                    });

                                    $btn.off('click').on('click', function () {
                                        mg.ui.errormodal({ title: mg.translations.NotAllowed, html: '<div>' + errors.join('.</div><div>') + '.</div>', onClose: onErrorModalClose });
                                    }).removeAttr('disabled').addClass('allow-click'); // Removing the disabled attribute, and adding the allow-click class, in order for the new onclick to work
                                }
                            };

                            handleAction(data.DeleteAction, 'delete-calendar-item', props.onDeleteErrorModalClose);
                            handleAction(data.EditAction, 'edit-calendar-item');
                            handleAction(data.PayAction, 'pay-calendar-item');

                            $.isFunction(props.onOpen) && props.onOpen();
                        }
                    });

                    var $expandable = $('.expandable', '#' + this._modalDetails.id);

                    var setTitle = function (title) {
                        $expandable.find('> a > span:first-child').html(title);
                    };

                    $expandable.on('show.bs.collapse', function () {
                        setTitle(mg.translations.HideChoices);
                    }).on('hide.bs.collapse', function () {
                        setTitle(mg.translations.SeeYourChoices);
                    });
                }, 800);

            };

            if (props.getDetailsFunc && $.isFunction(props.getDetailsFunc))
                props.getDetailsFunc().done(done);
            else
                getDetails(itemTime, slotID, compID, listType, maxExpand, filterType, filterPeriodFrom, filterPeriodTo).done(done);
        }

        showDeleteCompetitionSignup(compID) {
            this.showDetails(null, null, compID, null, null, null, null, null, {
                renderDetailsAsHidden: true, // We want the initital Details view to be rendered as hidden, as the user would otherwise see a flicker when we switch to the Delete view. We could have used an onBeforeShow on the modal isntead, but that would be fired before the modal initialization returns, which didn't work too well with the flow we needed here.
                getDetailsFunc: () => {
                    const url = '/Site/Calendar/?handler=CompetitionDetails';

                    const data = {
                        compID
                    };

                    return _.ajax.get(url, data); // Returning the ajax.get should allow us to use a .done on the return type.
                }, onOpen: () => {
                    $('.delete-calendar-item', '#' + this._modalDetails.id).trigger('click');

                    if ($('.details-cancel', '#' + this._modalDetails.id).attr('data-step') == 1) {
                        $('#btn-delcalendaritem-back').hide(); // Hide the button that goes back to the "Who do you want to remove" step.
                    }
                    else {
                        $('#btn-delcalendaritem-cancel').hide(); // Hide the button that goes back to the details view.
                    }
                },
                onDeleteErrorModalClose: () => {
                    this._modalDetails.close();
                },
                onDeleteSuccess: () => {
                    window.location && $.isFunction(window.location.reload) && window.location.reload();
                }
            });
        }

        preparePopovers(target, src) {
            let $wrapper;

            if (target === 'future') {
                $wrapper = $('.calendar-futurerounds-wrapper');
            } else if (target === 'previous') {
                $wrapper = $('.calendar-previousrounds-wrapper');
            }

            const $container = $wrapper;

            $('.avatars-wrapper', $wrapper).each((idx, elem) => {
                const $this = $(elem);
                const time  = $this.parents('.calendar-round-item').attr('data-time');
                let item;

                $.each(src, (k, v) => {
                    if (v.Time === time) {
                        item = v;
                        return false;
                    }
                });

                item && _.ui.popover.create($this, {
                    content: [
                        '<div class="calendar-popover">',
                            (() => {
                                let res = '';

                                $.each(item.Players, (k, v) => {
                                    res += [
                                        '<div class="player">',
                                            '<i class="icon icon-' + _.getGenderIconClass(v.Gender) + '"></i>',
                                            '<span>' + v.Name + (v.HCP ? ' ' + v.HCP : '') + '</span>',
                                        '</div>'
                                    ].join('');
                                });

                                return res;
                            })(),
                        '</div>'
                    ].join(''),

                    container : $container,
                    boundary  : $container[0],
                    placement : 'top' // We try to place this on top if possible
                });
            });
        }

        openBooking(slotId, showPaymentDirectly) {
            var that = this;

            _.ajax.post('/Site/Calendar/?handler=RefreshDetails', { slotID: slotId }).done(function (data) {
                if (data && !data.ErrorMessage) {
                    _.actions.findTeeTime(slotId, showPaymentDirectly, () => {
                        that._modalDetails.close();
                    });
                }
                else {
                    mg.ui.errormodal({ title: mg.translations.Error, html: data.ErrorMessage.replace('\r\n', '<br>').replace('\n', '<br>') });
                }
            });
        }

        openCompetitionSignup(competitionID, showPaymentDirectly) {
            var method = 1;

            if (this._modalDetails._data.Teams && this._modalDetails._data.Teams.length) {
                method = 2; // TODO - We have to determine the method differently, the setup may not allow either of these values
            }

            mg.redirect('/Competition/Entry/' + competitionID + '/' + method + (showPaymentDirectly ? '/payment' : ''));
        }

        redirectToOMG() {
            window.mg.openTab('{oMG}/MyPage/Calendar/Calendar.aspx');
        }

        saveToCalendar(time, clubName, courseName) {
            clubName   = encodeURIComponent(clubName || '').replace(/'/g, '\\\'');
            courseName = encodeURIComponent(courseName || '').replace(/'/g, '\\\'');

            var url_google = '/handlers/booking/SaveToCalendar/' + time + '/' + clubName + '/' + courseName + '/google';
            var url_iCal   = '/handlers/booking/SaveToCalendar/' + time + '/' + clubName + '/' + courseName;

            var html = [
                '<div class="row">',
                    '<div class="col">',
                        '<button class="btn btn-primary btn-outline-white w-100" onclick="window.open(\'' + url_google + '\'); mg.calendar._saveToCalendarModal.close();">Google</button>',
                    '</div>',
                    '<div class="col">',
                        '<button class="btn btn-primary btn-outline-white w-100" onclick="window.open(\'' + url_iCal + '\'); mg.calendar._saveToCalendarModal.close();">iCal/Outlook</button>',
                    '</div>',
                '</div>'
            ].join('');

            _.calendar._saveToCalendarModal = _.ui.confirmmodal({ html: html, title: mg.translations.SaveToCalendar, hideAllButtons: true });
        }

        deleteBooking() {
            var modalTitle = _.translations.CancelTeeTime;
            this.deleteCalendarItemShared(modalTitle);
        }

        deleteCompetitionSignup() {
            var modalTitle = _.translations.DeleteCompetitionSignup;
            this.deleteCalendarItemShared(modalTitle);
        }

        deleteCalendarItemShared(modalTitle) {
            const $modal      = $('#' + this._modalDetails.id);
            const $modalTitle = $('.modal-title', $modal);
            const $modalBody  = $('.modal-body', $modal);

            var data = this._modalDetails._data;
            var isCompetition = data.CompetitionID !== undefined && data.CompetitionID !== null;
            var that = this;

            this.deleteCalendarItem({
                $wrapper: $modalBody,
                data: data,
                allowDeleteAll: data.AllowDeleteAll,
                isCompetition: isCompetition,
                onShow: function () {
                    $('> .details', $modalBody).hide();
                    $modalTitle.html(modalTitle);
                },
                onCancel: function () {
                    $('> .details', $modalBody).show();
                    $modalTitle.html(that._modalDetails.title);
                },
                onSuccess: function () {
                    var onDeleteSuccess = that._modalDetails._data ? that._modalDetails._data.onDeleteSuccess : null;
                    that._modalDetails.close();
                    _.calendar && $.isFunction(_.calendar.updateFutureRounds) && _.calendar.updateFutureRounds();

                    onDeleteSuccess && $.isFunction(onDeleteSuccess) && onDeleteSuccess();
                }
            });
        }

        deleteCalendarItem(options) {
            var props = $.extend(true, {
                $wrapper: null,
                allowDeleteAll: false,
                preSelectView: undefined, // Can be set to 0 or 1 to force either of these views
                preSelectViewViewShowHeader: undefined,
                isDeleteSelf: false,
                render: function () {
                    var cancelTitle = mg.translations.WhoDoYouWantToRemoveBooking;
                    var rdoAllText = mg.translations.CancelTheEntireTeeTime;
                    var rdoOnlyMeText = mg.translations.OnlyRemoveMeFromTheBall;
                    var btnDeleteSaveText = mg.translations.CancelTeeTime;

                    if (props.isCompetition) {
                        cancelTitle = mg.translations.WhoDoYouWantToRemoveCompetition;
                        rdoAllText = mg.translations.TheEntireTeam;
                        rdoOnlyMeText = mg.translations.OnlyMyself;
                        btnDeleteSaveText = mg.translations.DeleteCompetitionSignup;
                    }

                    var data = props.data;
                    var isSoloBooking = false;

                    if (props.isCompetition) {
                        var teams = data ? data.Teams : null;
                        isSoloBooking = !teams || teams.length === 0; // TODO - Can the entry be in a TeeTime with teams without being in a team themself?
                    }
                    else {
                        isSoloBooking = data && data.Players && data.Players.length === 1 && data.Players[0].IsSelf;
                    }

                    if (isSoloBooking) {
                        props.allowDeleteAll = true; // Regardless of what was set before, if you are alone in your booking you must be allowed to delete the entire thing. Otherwise you cannot delete a booking where you are the only one left if you were not the booker.
                    }

                    props.$wrapper.append([
                        '<div class="details-cancel" data-step="0">',
                            '<div class="details-cancel-body" data-step="0">',
                                '<h4>' + cancelTitle + '</h4>',

                                '<div class="form-group">',
                                    (function () {
                                        return props.allowDeleteAll ? [
                                            '<div class="custom-control custom-radio custom-control-inline">',
                                                '<input type="radio" id="rdo-delcalendaritem-0" name="rdo-delcalendaritem" class="custom-control-input" value="0">',
                                                '<label class="custom-control-label" for="rdo-delcalendaritem-0">', rdoAllText, '</label>',
                                            '</div>'
                                        ].join('') : '';
                                    })(),
                                    '<div class="custom-control custom-radio custom-control-inline">',
                                        '<input type="radio" id="rdo-delcalendaritem-1" name="rdo-delcalendaritem" class="custom-control-input" value="1">',
                                        '<label class="custom-control-label" for="rdo-delcalendaritem-1">', rdoOnlyMeText, '</label>',
                                    '</div>',
                                '</div>',
                            '</div>',
                            '<div class="details-cancel-body" data-step="1">',
                            '</div>',

                            '<hr>',

                            '<div class="details-cancel-footer" data-step="0">',
                                '<button class="btn btn-primary" id="btn-delcalendaritem-next">' + _.translations.Next + '</button>',
                                '<button class="btn btn-blacksqueeze" id="btn-delcalendaritem-cancel">' + _.translations.Back + '</button>',
                            '</div>',
                            '<div class="details-cancel-footer" data-step="1">',
                                '<button class="btn btn-primary" id="btn-delcalendaritem-save">' + btnDeleteSaveText + '</button>',
                                '<button class="btn btn-blacksqueeze" id="btn-delcalendaritem-back">' + _.translations.Back + '</button>',
                                '<div class="spinner spinner-blue invisible"></div>',
                                '<div class="paid-warning"><i class="icon icon-info"></i><span class="paid-warning-text"></span></div>',
                            '</div>',
                        '</div>'
                    ].join(''));

                    var that = this;

                    $('#btn-delcalendaritem-next').off('change').on('click', function () {
                        that.next();
                    });

                    $('#btn-delcalendaritem-cancel').off('change').on('click', function () {
                        that.cancel();
                    });

                    $('#btn-delcalendaritem-save').off('change').on('click', function () {
                        that.save();
                    });

                    

                    var preSelectView = undefined;

                    if (isSoloBooking) {
                        preSelectView = 0; // This is a solo-booking, so there's no need to ask the user to select who they want to remove. Default to delete all
                    }
                    else if (!props.allowDeleteAll) {
                        preSelectView = 1; // Force Delete Only Me

                        if (props.preSelectViewShowHeader === undefined) {
                            props.preSelectViewShowHeader = true; // Set this to true if it was not already set
                        }
                    }

                    if (preSelectView === undefined && props.preSelectView !== undefined)
                        preSelectView = props.preSelectView; // Only if preSelectView has not been resolved to anything so far, we allow using the specified value. This allows the resolved value to override any parameter
                    //MGNY-864 Back button will bind to cancel, if we're going to call next() automatically below and skip the first step of the gui.
                    var btnBackFuncPtr = preSelectView !== undefined ? that.cancel : that.back;
                    $('#btn-delcalendaritem-back').off('change').on('click', function () {
                        btnBackFuncPtr();
                    });

                    if (preSelectView !== undefined) {
                        $('#rdo-delcalendaritem-' + preSelectView).prop('checked', true);
                        that.next(!props.preSelectViewShowHeader);
                    }

                    $.isFunction(props.onShow) && props.onShow();
                },
                next: function (hideHeaderText) {
                    const $detailsCancel = $('.details-cancel', props.$wrapper);
                    const $body0 = $('.details-cancel-body[data-step="0"]', $detailsCancel);
                    const $body1 = $('.details-cancel-body[data-step="1"]', $detailsCancel);
                    const $rdo = $('input[name="rdo-delcalendaritem"]:checked', $body0);

                    const html = [];

                    if (!$rdo.length)
                        return;

                    var data = props.data;
                    var isCompetition = props.isCompetition;

                    var headerText = '';
                    var youAreNowRemovingText = isCompetition ? mg.translations.YouAreNowRemovingCompetition : mg.translations.YouAreNowRemovingBooking;
                    var calendarItemHasAPaidFeeText = isCompetition ? mg.translations.TheSignupHasAPaidFee : mg.translations.TheBookingHasAPaidFee;
                    var playerHasAPaidFeeText = mg.translations.ThePlayerHasAPaidFee;
                    var paidWarning = '';
                    var players = [];

                    switch ($rdo.val()) {
                        case '0':
                            headerText = isCompetition ? mg.translations.TheEntireTeam : mg.translations.CancelTheEntireTeeTime;
                            var showTeamName = isCompetition && data.Players.length < 2 && data.Teams && data.Teams.length > 0 ? true : false;

                            if (showTeamName) // TODO - If we later reintroduce team members in the Details modal, we might want to revisit this, and perhaps show team members when possible, and fall back to team name or "The entire team".
                                players.push('<b>' + (data.Teams[0].Name || mg.translations.TheEntireTeam) + '</b>');

                            $.each(data.Players, function (k, v) {
                                !showTeamName && players.push('<b>' + v.Name + '</b>');

                                if (v.TotalPaid && v.TotalPaid > 0 && !paidWarning) {
                                    paidWarning = calendarItemHasAPaidFeeText;
                                }
                            });

                            break;

                        case '1':
                            headerText = isCompetition ? mg.translations.OnlyMyself : mg.translations.OnlyRemoveMeFromTheBall;
                            var player = data.Players.find((o) => _.user && o.GolfID === _.user.GolfId);

                            if (player) {
                                players.push('<b>' + player.Name + '</b>');

                                if (player.TotalPaid && player.TotalPaid > 0) {
                                    paidWarning = playerHasAPaidFeeText;
                                }
                            }

                            break;
                    }

                    if (data.AllowRefundOnDelete) // We have three scenarios. 1: Nothing has been paid, we show nothing. 2: Something was paid, auto refund enabled, we inform the user. 3: Something was paid, auto refund is not enabled/not possible, we inform the user.
                        paidWarning = mg.translations.AnyRefundOfPaidCompetitionFeesHappensAutomatically + '.';
                    else if (paidWarning)
                        paidWarning += '. ' + mg.translations.DependingOnTheClubsSettingsRefundMayHappenAutomatically + '.';

                    html.push(
                        hideHeaderText ? '' : '<h4>' + headerText + '</h4>',
                        '<p>',
                            youAreNowRemovingText + ':<br>',
                            '<small>' + players.join('<br>') + '</small>',
                        '</p>'
                    );

                    $detailsCancel.attr('data-step', '1');
                    $body1.empty().html(html.join(''));
                    $('.paid-warning', $detailsCancel).find('.paid-warning-text').html(paidWarning).end().toggleClass('d-flex', paidWarning !== '');
                },
                back: function () {
                    const $detailsCancel = $('.details-cancel', props.$wrapper);

                    $detailsCancel.attr('data-step', '0');
                },
                save: function () {
                    const $detailsCancel = $('.details-cancel', props.$wrapper);
                    const $body0 = $('.details-cancel-body[data-step="0"]', $detailsCancel);
                    const $rdo = $('input[name="rdo-delcalendaritem"]:checked', $body0);
                    const $btns = $('.details-cancel-footer .btn', $detailsCancel);
                    const $spinner = $('.details-cancel-footer .spinner', $detailsCancel);

                    if (!$rdo.length)
                        return;

                    $btns.prop('disabled', true);
                    $spinner.removeClass('invisible');

                    var showError = function (errorMessage) {
                        mg.ui.errormodal({ html: errorMessage, title: mg.translations.Error });
                    };

                    var data = props.data;
                    var isCompetition = props.isCompetition;
                    var bookingURLBase = '/handlers/Booking/';
                    var url = null;
                    var lilumTransactionName = null;
                    var o = {};

                    if (isCompetition) {
                        url = '/handlers/Competition/DeleteCompetitionSignup';
                        o.competitionID = data.CompetitionID;
                        o.deleteEntireTeam = $rdo.val() === '0';
                        o.allowRefundOnlinePayments = data.AllowRefundOnDelete;
                    }
                    else {
                        switch ($rdo.val()) {
                            case '0':
                                url = bookingURLBase + 'DeleteBooking';
                                lilumTransactionName = 'DeleteBooking';
                                o.slotId = data.SlotID;

                                break;

                            case '1':
                                const players = data.Players.filter((o) => _.user && o.GolfID === _.user.GolfId && o.ParticipantID);

                                if (players) {
                                    url = bookingURLBase + 'DeletePlayerSelf';
                                    lilumTransactionName = 'DeletePlayerSelf';
                                    o.slotId = data.SlotID;
                                    o.participantId = players[0].ParticipantID;
                                }

                                break;
                        }
                    }

                    lilumTransactionName && mg.lilumStartTransaction(lilumTransactionName);

                    _.ajax.post(url, o).done((data) => {
                        if (data.Deleted) {
                            if (data.ShowRefundWarning) {
                                mg.ui.infomodal({ html: mg.translations.YourSignupWasDeletedButWeWereUnableToRefund, title: mg.translations.PleaseNote, hideButtonOK: false }); // TODO - Text and button?
                            }

                            $.isFunction(props.onSuccess) && props.onSuccess();
                            return;
                        }

                        $btns.prop('disabled', false);
                        $spinner.addClass('invisible');

                        showError(data.ErrorMessage);
                    }).always(() => {
                        lilumTransactionName && mg.lilumStopTransaction(lilumTransactionName);
                    });
                },
                cancel: function () {
                    $('> .details-cancel', props.$wrapper).remove();

                    $.isFunction(props.onCancel) && props.onCancel();
                }
            }, options);

            props.render();

            return props;
        }

        registerHCP(slot) {
            _.hcp.registerRound.open(slot, _.translations.HandicapRounds);
        }
    }

    _.calendar = new Calendar();
})(jQuery, window);
